import { type ReactElement, type ReactNode } from 'react'
import { type AttachmentData, type AttachmentId } from '@terros/common'
import { Skeleton, Stack, Text } from '@mantine/core'
import { useAttachment } from '@front/model'
import { AuditInfoSection } from '../auditInfo'

type AttachmentLoaderProps = {
  attachmentId: AttachmentId
  children: (props: { data: AttachmentData }) => ReactNode
}

export const AttachmentLoader = ({ attachmentId, children }: AttachmentLoaderProps): ReactNode => {
  const { data, isLoading, error } = useAttachment(attachmentId)

  if (isLoading) return <Skeleton h={32} />
  if (error) return <Text>Error loading attachment: {error}</Text>
  if (!data) return <Text>No attachment data received</Text>

  return children({ data })
}

const Lightbox = ({ attachment }: { attachment: AttachmentData }): ReactElement => {
  const createAudit = attachment.modifiedBy?.sort((a, b) => a.timestamp - b.timestamp)[0]
  return (
    <Stack>
      <AuditInfoSection createdAt={createAudit?.timestamp} createdBy={createAudit?.userId} />
      <img alt={attachment.filename} src={attachment.downloadUrl} />
    </Stack>
  )
}
